import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useCallback, useMemo } from "react";

import { LIST_PULL_REQUESTS } from "./gql";

const useStackPullRequests = (stackId: string, options: { skip: boolean }) => {
  const { data, error, loading, networkStatus, refetch } = useQuery(LIST_PULL_REQUESTS, {
    variables: { id: stackId },
    skip: options.skip,
    notifyOnNetworkStatusChange: true,
  });

  const pullRequests = useMemo(() => data?.stack?.pullRequests ?? [], [data?.stack?.pullRequests]);
  const refresh = useCallback(() => refetch(), [refetch]);

  return {
    pullRequests,
    error,
    isPageLoading: loading && !data?.stack,
    isRefreshing: networkStatus === NetworkStatus.refetch,
    isEmpty: pullRequests.length === 0,
    isNotFound: !options.skip && !data?.stack,
    refresh,
  };
};

export default useStackPullRequests;
